exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "loans-sign-up-confirmation-form{display:block}loans-sign-up-confirmation-form .sign-up-buttons{height:50px}loans-sign-up-confirmation-form .sign-up-buttons .btn-default{margin-right:30px}confirm-close-modal .modal-body .small-description{white-space:pre-wrap;text-align:left}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/loans.module/features/loansSignUp/loansSignUpConfirmationModal/loansSignUpConfirmationModal.scss
// module id = 1936
// module chunks = 0